export default __webpack_public_path__ + "static/media/thumbnail.5aa2928c.webp";